"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeCharacterMap = serializeCharacterMap;
exports.deserializeCharacterMap = deserializeCharacterMap;
exports.applyCharacterMapSlot = applyCharacterMapSlot;
exports.getCharacterMapSlot = getCharacterMapSlot;
exports.unwrapEntityVariableValue = unwrapEntityVariableValue;
exports.getCurrentEntityCharacterMap = getCurrentEntityCharacterMap;
function serializeCharacterMap(map) {
    return JSON.stringify(map);
}
function deserializeCharacterMap(serializedMap) {
    try {
        const parsed = JSON.parse(serializedMap);
        if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
            throw new Error('Character map value must be a JSON object');
        }
        const result = {};
        for (const [key, value] of Object.entries(parsed)) {
            if (typeof key === 'string' && key.length > 0 && typeof value === 'string') {
                result[key] = value;
            }
        }
        return result;
    }
    catch (error) {
        console.warn(`Failed to deserialize character_map: ${error}`);
        return {};
    }
}
function applyCharacterMapSlot(map, characterKey, slotValue, options) {
    const next = { ...map };
    if (options?.clear || slotValue === '') {
        delete next[characterKey];
    }
    else {
        next[characterKey] = String(slotValue);
    }
    return next;
}
function getCharacterMapSlot(map, characterName) {
    if (!characterName) {
        return '';
    }
    return map[characterName] ?? '';
}
function unwrapEntityVariableValue(variable, characterName) {
    if (variable.type === 'character_map') {
        return getCharacterMapSlot(deserializeCharacterMap(String(variable.value ?? '{}')), characterName);
    }
    return variable.value;
}
/** Current entity instance map named `name`, if that variable is a character_map. */
function getCurrentEntityCharacterMap(host, playerId, name) {
    if (!host) {
        return undefined;
    }
    const uuid = host.getCurrentEntityId(playerId);
    if (!uuid) {
        return undefined;
    }
    const variable = host.getEntityVariable(uuid, name);
    if (!variable || variable.type !== 'character_map') {
        return undefined;
    }
    return { uuid, variable };
}
//# sourceMappingURL=characterMap.js.map